<template>
	<v-container id="app">
		<router-view></router-view>
	</v-container>
</template>

<style>
#app {
	color: white;
	background-color: black;
	height: auto;
	font-family: 'custom';
	max-width: 100%;
	padding: 0;
}
</style>

<script>
import config from './config.json';

export default {
	name: 'App',
	created: async function() {
		this.$store.commit('setJsonData', config);
	},
};
</script>
